import Papa from "papaparse";
import Helper from "./Helper";
import SharesDropDown from "./SharesDropDown";
import SharesFilters from "./SharesFilters";
import * as S from './../Vars/shares';
import SharesShared from "./SharesShared";
import SharesData from "./SharesData";

/**
 * Shares Page Master Class
 * ------------------------
 * pulls all the strings and puts it together
 */
class SharesCSVHandler {
  constructor(config = {}) {
    const {} = config;

    // if there's a filter file input, parse file and send to filter Parser
    if (S.filters.length > 0) {
      const sFI = new SharesFilters();
      S.filters.forEach((filterFile, index) => {
        const file = filterFile.value;
        Papa.parse(file, {
          encoding: "ISO-8859-1",
          download: true,
          complete: (results) => {
            sFI.filterParser(results.data);
          },
        });
      });
    }

    // if there's a shares file input parse shares file
    if (S.shares.length > 0) {
      const sSD = new SharesData();
      S.shares.forEach((sharesFile, index) => {
        const file = sharesFile.value;
        Papa.parse(file, {
          encoding: "ISO-8859-1",
          download: true,
          complete: (results) => {
            sSD.sharesParser(results.data);
          },
        });
      });
    }

    // if there's dropdown inputs, parse files and send them to Dropdown Parser
    if (S.dropDowns.length > 0) {
      const sDD = new SharesDropDown();
      S.dropDowns.forEach((dd, index) => {
        const file = dd.value;
        Papa.parse(file, {
          encoding: "ISO-8859-1",
          download: true,
          complete: (results) => {
            sDD.dropParser(results.data, index);
          },
        });
      });
    }

    // register sorting functionality for sorting radio buttons
    if (S.sorters.length > 0) {
      S.sorters.forEach((input) => {
        input.addEventListener("click", (e) => {
          const currentOrder = input.value;
          const currentFilter = document.querySelector('input[name="share-filter"]:checked').value;
          SharesShared.sort(currentOrder, currentFilter);
        });
      });
    }

    if (S.viewSwitches.length > 0) {
      S.viewSwitches.forEach((switcher) => {
        if (switcher.checked) {
          S.currentView = switcher.value;
        }
        switcher.addEventListener("click", (e) => {
          if (S.currentView != switcher.value) {
            Helper.removeClass(S.sharesContainer, S.currentView + "-view");
            S.currentView = switcher.value;
            Helper.addClass(S.sharesContainer, S.currentView + "-view");
          }
        });
      });
    }
  }
}

export default SharesCSVHandler;
